var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 21H15.4V12.6H12.6V21ZM14 9.8C14.3967 9.8 14.7294 9.6656 14.9982 9.3968C15.267 9.128 15.4009 8.79573 15.4 8.4C15.4 8.00333 15.2656 7.6706 14.9968 7.4018C14.728 7.133 14.3957 6.99907 14 7C13.6033 7 13.2706 7.1344 13.0018 7.4032C12.733 7.672 12.5991 8.00427 12.6 8.4C12.6 8.79667 12.7344 9.1294 13.0032 9.3982C13.272 9.667 13.6043 9.80093 14 9.8ZM14 28C12.0633 28 10.2433 27.6323 8.54 26.8968C6.83667 26.1613 5.355 25.1641 4.095 23.905C2.835 22.645 1.83773 21.1633 1.1032 19.46C0.368667 17.7567 0.000933333 15.9367 0 14C0 12.0633 0.367733 10.2433 1.1032 8.54C1.83867 6.83667 2.83593 5.355 4.095 4.095C5.355 2.835 6.83667 1.83773 8.54 1.1032C10.2433 0.368667 12.0633 0.000933333 14 0C15.9367 0 17.7567 0.367733 19.46 1.1032C21.1633 1.83867 22.645 2.83593 23.905 4.095C25.165 5.355 26.1627 6.83667 26.8982 8.54C27.6337 10.2433 28.0009 12.0633 28 14C28 15.9367 27.6323 17.7567 26.8968 19.46C26.1613 21.1633 25.1641 22.645 23.905 23.905C22.645 25.165 21.1633 26.1627 19.46 26.8982C17.7567 27.6337 15.9367 28.0009 14 28Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.9477193388a4c0fe61ff7f0ffee1198f.svg";
export { ForwardRef as ReactComponent };